// extracted by mini-css-extract-plugin
module.exports = {"post":"blog-post-module--post--3laZV","description":"blog-post-module--description--12VC7"};